// removed by extract-text-webpack-plugin
module.exports = {"header":"Mobile__header__2hPQC","headings":"Mobile__headings__tiWLQ","row":"Mobile__row__wmrj6","checkmark":"Mobile__checkmark__3AeDm","item":"Mobile__item__1Wwuw","intro":"Mobile__intro__3U5Yv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuiteKey/Options/BenefitsContent/Mobile/Mobile.scss
// module id = 428
// module chunks = 0